import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/reservas';

class ReservationsService {
    static async registerReservation(reservation) {
        const response = await api.post(BASE_PATH, reservation);
        return response.data;
    }

    static async listByClientAndDate(clientCode, date) {
        const response = await api.get(`${BASE_PATH}/client/${clientCode}`, { params: { date } });
        return response.data;
    }

    static async listByResponsibleAndDate(clientCode, responsibleId, date) {
        const response = await api.get(`${BASE_PATH}/client/${clientCode}/responsible/${responsibleId}`, {
            params: date ? { date } : {}
        });
        return response.data;
    }

    static async getById(id) {
        const response = await api.get(`${BASE_PATH}/${id}`);
        return response.data;
    }

    static async cancelReservation(id) {
        const response = await api.post(`${BASE_PATH}/${id}/cancel`);
        return response.data;
    }
}

export default ReservationsService;
